export const erefQueueKey = (erefId: number) => `eref-${erefId}`
